/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-11-09 14:25:00
 */

 import {default as CellOperate} from "../../../../components/agGridComponent/cellOperate";
 import {ColDefCustom, default as AgGridVueCustomTsx} from "../../../../components/agGridCustom/agGridVueCustomTsx";
 import _ from 'lodash'
 import ListPageService from "../../../../types/ListPage";
 import override from "../../../../dectorators/override";
 import {DateTimeUtil} from "../../../../util/dateTimeUtil";
 import {QueryFormVOI} from "../../../../components/queryForm/queryForm";
 import TestApi, {TestDOI} from '../api/testApi';
 import SolutionKey from '../solutionKey';
 import AreaCascader from 'src/components/areaCascader/areaCascader';
 import CommonSelect from 'src/components/SelectCustom/commonSelect';
 import Input from 'src/types/iview/Input';
 import EnumStationType from 'src/enums/enumStationType';
 import solutionKeyAddModel from '../solutionKeyAddModel';
 import alertSolutionKeyDetailModal from '../solutionKeyDetailModel';
 import { Toast } from 'src/util/toast';
 import EnumOperates from 'src/enums/enumOperates';
 
 export default class SolutionKeyService extends ListPageService {
     ctx: SolutionKey;

     constructor (ctx: SolutionKey) {
        super()
        this.ctx = ctx
     }
 
     @override
     createColumns (): ColDefCustom [] {
         let t = this
         return [
            {
                headerName: '报错信息',
                field: 'error_info',
                minWidth: 120
            },
             {
                 headerName: '报错号',
                 field: 'error_no',
                 minWidth: 190,
             },
             {
                 headerName: '操作时间',
                 field: 'operate_datetime',
                 minWidth: 160,
             },
             {
                 headerName: '操作人',
                 field: 'operator',
                 minWidth: 100,
             },
             {
                 headerName: '操作',
                 field: 'operate',
                 minWidth: 150,
                 maxWidth: 150,
                 cellRendererFramework: CellOperate,
                 cellRendererFrameworkOpt: [
                    {
                         text: '详情',
                         async click (params) {
                             let data: TestDOI.RowDataI = params.data;
                             console.log(data)
                             let res = await alertSolutionKeyDetailModal(data.id, data.error_info, data.error_no)
                             if(res) {
                                 t.searchTable()
                             }
                         }
                    },
                    {
                        text: '删除',
                        async click(params) {
                            let res = await Toast.confirm();
                            if (!res) {
                                return;
                            }
                            let data: TestDOI.RowDataI = params.data;
                            await t.delete(data.id);
                        },
                    },
                    {
                        text: '修改',
                        async click (params) {
                            let data: TestDOI.RowDataI = params.data;
                            let res = await solutionKeyAddModel(EnumOperates.Update.getName(), data.id);
                            if (res) {
                               t.searchTable();
                            }
                        }
                    },
                 ]
             },
         ]
     }

    async delete(id: number) {
        let { code } = await TestApi.delete({ id: id });
        if (code === 0) {
            Toast.success('删除成功');
            this.searchTable();
        }
    }
 
     @override
     creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            {
                component: Input,
                label: '',
                labelWidth: 20,
                width: 140,
                field: 'keyword',
                props: { value: '', placeholder: '关键字' },
            },
        ];
     }
     
     @override
     createBtnGroup(): Array<IconBtnItem> {
         let t = this;
         return [
            {
                text: '新增',
                async onClick() {
                     let res = await solutionKeyAddModel(EnumOperates.Add.getName());
                     if (res) {
                        t.searchTable();
                     }
                },
            },
         ];
     }
 
     @override
     initSearchParams (): void {
         this.ctx.searchParams = {
             ...this.ctx.queryForm.getQueryObj<TestDOI.QueryRowDataParamsI>(),
             page_index: this.ctx.currentPage,
             page_size: this.ctx.pageSize,
         }
         this.ctx.currentPage = 1
     }
 
     @override
     async searchTable () {
         let ctx = this.ctx
         let ag = (this.ctx.$refs.ag) as AgGridVueCustomTsx
         ag.showLoading()
         let {code, data} = await TestApi.searchList({
             ...ctx.searchParams,
             page_size: ctx.pageSize,
             page_index: ctx.currentPage
         })
         ag.hideLoading()
         if (code === 0) {
             ctx.rowData = data.data_info || [];
             ctx.total = data.page_count
         }
     }
 
 }